import { render, staticRenderFns } from "./PortalHomePage.vue?vue&type=template&id=e2b90336&scoped=true&"
import script from "./PortalHomePage.vue?vue&type=script&lang=js&"
export * from "./PortalHomePage.vue?vue&type=script&lang=js&"
import style0 from "./PortalHomePage.vue?vue&type=style&index=0&id=e2b90336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b90336",
  null
  
)

export default component.exports